import { Component, OnInit } from '@angular/core';
import { AmChartsService, AmChart } from "@amcharts/amcharts3-angular";
import { ApplicationService } from '../application/application.service';
import { MessagesService } from './messages.service';
import * as moment from 'moment';
import { _ } from 'underscore';
import { TranslateService } from '@ngx-translate/core'; 
import { MessageService } from "../message/message.service";
import { SharedServiceService } from '../shared-service.service';
@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent implements OnInit {

  chart: AmChart;
	chartReceived: AmChart;
	templateChart: AmChart;
	sentChartOptions = {
		"type": "serial",
		"theme": "none",
		"dataProvider": [],
		"valueAxes": [{
			"gridColor": "#FFFFFF",
			"gridAlpha": 0.2,
			"dashLength": 0,
			"minimum": 0
		}],
		"gridAboveGraphs": true,
		"startDuration": 1,
		"graphs": [{
			"balloonText": "[[category]]: <b>[[value]]</b>",
			"fillAlphas": 0.8,
			"lineAlpha": 0.2,
			"type": "column",
			"valueField": "value",
			"fillColors": ["#1E87F0", "#40BCF9"],
			"fixedColumnWidth": 30
		}],
		"chartCursor": {
			"categoryBalloonEnabled": false,
			"cursorAlpha": 0,
			"zoomable": false
		},
		"categoryField": "year",
		"categoryAxis": {
			"gridPosition": "start",
			"gridAlpha": 0,
			"tickPosition": "start",
			"tickLength": 20,
			"labelPosition": "middle",
			"labelRotation": 45
		},
		"export": {
			"enabled": true
		}
	};

	receivedChartOptions = {
		"type": "serial",
		"theme": "none",
		"dataProvider": [],
		"valueAxes": [{
			"gridColor": "#FFFFFF",
			"gridAlpha": 0.2,
			"dashLength": 0,
			"minimum": 0
		}],
		"gridAboveGraphs": true,
		"startDuration": 1,
		"graphs": [{
			"balloonText": "[[category]]: <b>[[value]]</b>",
			"fillAlphas": 0.8,
			"lineAlpha": 0.2,
			"type": "column",
			"valueField": "value",
			"fillColors": ["#1E87F0", "#40BCF9"],
			"fixedColumnWidth": 30
		}],
		"chartCursor": {
			"categoryBalloonEnabled": false,
			"cursorAlpha": 0,
			"zoomable": false
		},
		"categoryField": "year",
		"categoryAxis": {
			"gridPosition": "start",
			"gridAlpha": 0,
			"tickPosition": "start",
			"tickLength": 20,
			"labelPosition": "middle",
			"labelRotation": 45
		},
		"export": {
			"enabled": true
		}
	};

	templateChartOptions = {
		"type": "serial",
		"theme": "none",
		"dataProvider": [],
		"valueAxes": [{
			"gridColor": "#FFFFFF",
			"gridAlpha": 0.2,
			"dashLength": 0,
			"minimum": 0
		}],
		"gridAboveGraphs": true,
		"startDuration": 1,
		"graphs": [{
			"balloonText": "[[category]]: <b>[[value]]</b>",
			"fillAlphas": 0.8,
			"lineAlpha": 0.2,
			"type": "column",
			"valueField": "value",
			"fillColors": ["#1E87F0", "#40BCF9"],
			"fixedColumnWidth": 30
		}],
		"chartCursor": {
			"categoryBalloonEnabled": false,
			"cursorAlpha": 0,
			"zoomable": false
		},
		"categoryField": "year",
		"categoryAxis": {
			"gridPosition": "start",
			"gridAlpha": 0,
			"tickPosition": "start",
			"tickLength": 20,
			"labelPosition": "middle",
			"labelRotation": 45
		},
		"export": {
			"enabled": true
		}
	};

	applicationList: any;
	userData: any;
	public selectedApp: any={};
	bsValue = new Date();
	bsRangeValue: Date[];
	last30DaysToDate: any = moment().format('YYYY-MM-DD');
	last30DaysFromDate: any = moment().subtract(30, 'days').format('YYYY-MM-DD');
	toDate: any = moment();
	fromDate: any = moment().subtract(30, 'days');
	connectors: any;
	todaysDate: any = moment();
	chooseDate: boolean = false;
	noRecords: boolean = true;
	noRecordsReceived: boolean = true;
	noTemplateRecordsReceived: boolean = true;
	selectedConnector:any;
	apiDetails: any;
	receivedApiDetails: any;
	selectedPeriod: string;
	selectedDateRange: any;
	selectedRangeApiData: any;
	selectedRangeReceivedApiData: any;
	loadershow: boolean = false;
	totalCountByConnectors: any;
	totalMessagesCount: any;
	deviceConnectorsCount: any;
	messagingConnectorsCount: any;
	hsmCountByConnectors: any;
	todaysCount: any;
	weeklyCount: any;
	monthlyCount: any;
	yearlyCount: any;

	connectorName: any;	
	currentWeekStarts: any = moment();
	currentWeekEnds: any = moment();
	currentMonthStarts: any = moment();
	currentMonthEnds: any = moment();
	currentYearStarts: any = moment();
	currentYearEnds: any = moment();
	totalReceivedCountByConnectors: any;
	totalReceivedCount: any;
	deviceConnectorsReceivedCount: any;
	messagingConnectorsReceivedCount: any;
	todaysReceivedCount: any;
	weeklyReceivedCount: any;
	monthlyReceivedCount: any;
	yearlyReceivedCount: any;
	totalReceivedMessagesCount: any;
	totalReceivedDateCount: any;
	totalDateCount: any;
	totalSentMessages:number;
	totalSentMessageLoader = true;
	totalDateCountLoader = true;
	todaysCountLoader = true;
	weeklyCountLoader = true;
	monthlyCountLoader = true;
	yearlyCountLoader = true;
	totalCountLoader = true;
	totalCountByConnectorsLoader = true;
	hsmCountByConnectorsLoader = true;
	todaysReceivedCountLoader = true;
	weeklyReceivedCountLoader = true;
	monthlyReceivedCountLoader = true;
	yearlyReceivedCountLoader = true;

	totalReceivedCountByConnectorsLoader = true;
	totalReceivedDateCountLoader = true;
	totalReceivedMessages:number;
	totalReceivedMessageLoader:boolean;
	applicationId: string;
	showMessageSentStatus = true;
	showMessageReceivedStatus = false;
	dashboardChartSentDetails: any;
	dashboardChartReceivedDetails: any;
	dashboardChartTemplateDetails: any;
	selectedApplication : any;
  constructor(private AmCharts: AmChartsService
		, private applicationService: ApplicationService
		, private messagesService: MessagesService
		, public translate: TranslateService,
		private messageservice: MessageService, private sharedService : SharedServiceService) { }

  ngOnInit(): void {
    this.loadershow = true;
		this.selectedPeriod = 'day';
		this.bsRangeValue = [new Date(Date.parse(this.fromDate._d)), new Date(Date.parse(this.toDate._d))];
		this.userData = JSON.parse(localStorage.getItem('user'));
		this.selectedDateRange = 'last30';
		this.fromDate = moment(this.fromDate).format('YYYY-MM-DD');
		this.toDate = moment(this.toDate).format('YYYY-MM-DD');
		this.todaysDate = moment(this.todaysDate).format('YYYY-MM-DD');
		
		
		let args = {
			developerId: this.userData.id
		  };
		  this.getApplicationName(args);
		 
		 // console.log("applicationNamePass", this.sharedService.applicationNamePass);
		  this.selectedApplication = this.sharedService.applicationNamePass;
		  this.getApplicationList();
          this.sentTodaysCount();
          this.sentWeeklyCount();
		  this.sentMonthlyCount();
		  this.sentYearlyCount();
		  this.sentTotalMessages();
		  this.receivedTodaysCount();
		  this.receivedWeeklyCount();
		  this.receivedMonthlyCount();
		  this.receivedYearlyCount();
		  this.receivedTotalMessagesCount();
  }




  getApplicationName(args) {
  
    this.messageservice.getApplicationName(args).subscribe((data) => {
        this.applicationList = data.info;
        
		//this.sentTodaysCount(this.applicationList); 
    },(err)=>{
      console.log("Error op", err);
    });
  }












  getApplicationList() {
		
		
		let args = {developerId: this.selectedApplication.developerId};
	
	
		this.applicationService.getApplicationList(args).subscribe(async data => {
			this.loadershow = false;
			
			if(data && data.status == true) {
				this.applicationList = data.info;
			
		
				this.selectedApp = data.info[0]; 
				let connectorData = this.selectedApp ? await this.getConnectorsList() : undefined;
				
				if(connectorData && connectorData.status == true) {
				 
					this.connectors = connectorData['info'];
					this.selectedConnector = this.connectors[0];
					this.getDashboardChartDetails();
					this.sentDataCountSection();
					this.receivedDataCountSection();
					this.getDateWiseTotalMessageCount();
					this.getDatewiseTotalReceivedCount();
				}else {
					this.connectors = [];
					this.selectedConnector = '';
					this.totalDateCountLoader = false;
					this.totalDateCount = 0;
					this.totalSentMessageLoader = false;
					this.totalSentMessages = 0;
					this.todaysCountLoader = false;
					this.todaysCount = 0;
					this.weeklyCountLoader = false;
					this.weeklyCount = 0;
					this.monthlyCountLoader = false;
					this.monthlyCount = 0;
					this.yearlyCountLoader = false;
					this.yearlyCount = 0;
                    this.totalCountLoader = false;
                    this.totalMessagesCount = 0;

					this.totalCountByConnectorsLoader = false;
					this.totalCountByConnectors = 0;
					this.hsmCountByConnectorsLoader = false;
					this.hsmCountByConnectors = 0;
					this.totalReceivedDateCountLoader = false;
					this.totalReceivedDateCount = 0;
					this.totalReceivedMessageLoader = false;
					this.totalReceivedMessages = 0;
					this.todaysReceivedCountLoader = false;
					this.todaysReceivedCount = 0;
					this.weeklyReceivedCountLoader = false;
					this.weeklyReceivedCount = 0;
					this.monthlyReceivedCountLoader = false;
					this.monthlyReceivedCount = 0;
					this.yearlyReceivedCountLoader = false;
					this.yearlyReceivedCount = 0;
					this.totalReceivedMessagesCount = 0;
					this.totalReceivedCountByConnectorsLoader = false;
					this.totalReceivedCountByConnectors = 0;
				}
			}		
		});
	}

	/** CONNECTOR LIST CALL **/
	async getConnectorsList() {
		let args = {
			developerId: this.selectedApplication.developerId
			, applicationId: this.selectedApplication.applicationId
		};
		
		return await this.messagesService.getConnectorsList(args).toPromise();
	}

	sentDataCountSection() {
		let args = {
			developerId: this.selectedApplication.developerId,
			applicationId: this.selectedApplication.applicationId
		};

		this.getDateWiseTotalMessageCount();
		this.totalSentMsgCount(args);
		// this.sentTodaysCount();
		// this.sentWeeklyCount();
		// this.sentMonthlyCount();
		// this.sentYearlyCount();
		// this.sentTotalMessages();
		this.getSentCountByConnectors();
		if (this.selectedConnector.hasHsm){
			this.sentHsmCount();
		}
	}

	receivedDataCountSection() {
		let args = {
			developerId: this.userData.id,
			applicationId: this.selectedApp.id
		};

		this.getDatewiseTotalReceivedCount();
		this.totalReceivedMsgCount(args);
		// this.receivedTodaysCount();
		// this.receivedWeeklyCount();
		// this.receivedMonthlyCount();
		// this.receivedYearlyCount();
		// this.receivedTotalMessagesCount();
		this.getReceivedCountByConnectors();
	}

	sentTodaysCount() {
		this.todaysCountLoader = true;
		this.todaysDate = moment(this.todaysDate).format('YYYY-MM-DD');
		let args = {
			developerId: this.selectedApplication.developerId,
			applicationId: this.selectedApplication.applicationId,
			fromDate: this.todaysDate,
			toDate: this.todaysDate
		};
		
		this.messageservice.totalSentMsgCount(args).subscribe(async (data) => {
			if (data && data.status == true) {
				this.todaysCount = data.info.totalCount ? data.info.totalCount : 0;
				this.todaysCountLoader = false;
			} else {
				this.todaysCountLoader = false;
			}
		}, err => {
			this.todaysCountLoader = false;
		});
	}

	sentWeeklyCount() {
		this.weeklyCountLoader = true;
		this.currentWeekStarts = moment().startOf('week').format('YYYY-MM-DD');
		this.currentWeekEnds = moment().endOf('week').format('YYYY-MM-DD');
		let args = {
			developerId: this.selectedApplication.developerId,
			applicationId: this.selectedApplication.applicationId,
			fromDate: this.currentWeekStarts,
			toDate: this.currentWeekEnds
		}; 
		this.messageservice.totalSentMsgCount(args).subscribe((data) =>{
			this.weeklyCount = data.info.totalCount ? data.info.totalCount : 0;
			this.weeklyCountLoader = false;
		});
		
	}

	sentMonthlyCount() {
		this.monthlyCountLoader = true;
		this.currentMonthStarts = moment().startOf('month').format('YYYY-MM-DD');
		this.currentMonthEnds = moment().endOf('month').format('YYYY-MM-DD');

		let args = {
			developerId: this.selectedApplication.developerId,
			applicationId: this.selectedApplication.applicationId,
			fromDate: this.currentMonthStarts,
			toDate: this.currentMonthEnds
		}; 

         this.messageservice.totalSentMsgCount(args).subscribe( (data) =>{
			 this.monthlyCount = data.info.totalCount ? data.info.totalCount : 0;
				this.monthlyCountLoader = false;

		 } );

	
	}

	sentYearlyCount() {	
		this.yearlyCountLoader = true;
		this.currentYearStarts = moment().startOf('year').format('YYYY-MM-DD');
		this.currentYearEnds = moment().endOf('week').format('YYYY-MM-DD');
	
		let args = {
			developerId: this.selectedApplication.developerId,
			applicationId: this.selectedApplication.applicationId,
			fromDate: this.currentYearStarts,
			toDate: this.currentYearEnds
		}; 
		this.messageservice.totalSentMsgCount(args).subscribe( (data) => {
			
				this.yearlyCount = data.info.totalCount ? data.info.totalCount : 0;
				
				this.yearlyCountLoader = false;
			
		}, err => {
			this.yearlyCountLoader = false;
		});
	}

	sentTotalMessages(){
	  this.totalCountLoader=true;
	  let args = {
		developerId: this.selectedApplication.developerId,
		applicationId: this.selectedApplication.applicationId
	  }; 
	  this.messageservice.totalSentMsgCount(args).subscribe( (data) => {
			
		this.totalMessagesCount = data.info.totalCount ? data.info.totalCount : 0;
		
		this.totalCountLoader = false;
	
}, err => {
	this.totalCountLoader = false;
});
	}


	getSentCountByConnectors() {
		this.totalCountByConnectorsLoader = true;
		this.loadershow = true;
		let args = {
			developerId: this.selectedApplication.developerId,
			applicationId: this.selectedApplication.applicationId,
			connectorId: this.selectedConnector.id
		};
		this.applicationService.getNumberOfMessagesSentCount(args).subscribe(async (data) => {
			this.loadershow = false;
			if (data && data.status == true) {
				this.totalCountByConnectors = data.info; 
				this.totalCountByConnectorsLoader = false;
			} else {
				this.totalCountByConnectorsLoader = false;
			}		
		}, err => {
			this.totalCountByConnectorsLoader = false;
		});
	}

	sentHsmCount() {
		this.hsmCountByConnectorsLoader = true;
		let args = {
			developerId: this.selectedApplication.developerId,
			applicationId: this.selectedApplication.applicationId,
			connectorId: this.selectedConnector.id
		};
		
		this.applicationService.getHsmMessagesCount(args).subscribe(async (data) => {
			if (data && data.status == true) {
				this.hsmCountByConnectors = data.info;
				this.hsmCountByConnectorsLoader = false;
			} else {
				this.hsmCountByConnectorsLoader = false;
			}
		}, err => {
			this.hsmCountByConnectorsLoader = false;
		});
	}

	receivedTodaysCount() {
		this.todaysReceivedCountLoader = true;
		this.todaysDate = moment(this.todaysDate).format('YYYY-MM-DD');
		let args = {
			developerId: this.selectedApplication.developerId,
		applicationId: this.selectedApplication.applicationId,
			fromDate: this.todaysDate,
			toDate: this.todaysDate
		};
		this.applicationService.totalReceivedMsgCount(args).subscribe(async (data) => {
			if (data && data.status == true) {
				this.todaysReceivedCount = data.info.totalCount;
				this.todaysReceivedCountLoader = false;
			} else {
				this.todaysReceivedCountLoader = false;
			}
		}, err => {
			this.todaysReceivedCountLoader = false;
		});
	}

	receivedWeeklyCount() {
		this.weeklyReceivedCountLoader = true;
		this.currentWeekStarts = moment().startOf('week').format('YYYY-MM-DD');
		this.currentWeekEnds = moment().endOf('week').format('YYYY-MM-DD');
		let args = {
			developerId: this.selectedApplication.developerId,
		applicationId: this.selectedApplication.applicationId,
			fromDate: this.currentWeekStarts,
			toDate: this.currentWeekEnds
		};
		this.applicationService.totalReceivedMsgCount(args).subscribe(async (data) => {
			if (data && data.status == true) {
				this.weeklyReceivedCount = data.info.totalCount ? data.info.totalCount : 0;
				this.weeklyReceivedCountLoader = false;
			} else {
				this.weeklyReceivedCountLoader = false;
			}
		}, err => {
			this.weeklyReceivedCountLoader = false;
		});
	}

	receivedMonthlyCount() {
		this.monthlyReceivedCountLoader = true;
		this.currentMonthStarts = moment().startOf('month').format('YYYY-MM-DD');
		this.currentMonthEnds = moment().endOf('month').format('YYYY-MM-DD');
		let args = {
			developerId: this.selectedApplication.developerId,
		applicationId: this.selectedApplication.applicationId,
			fromDate: this.currentMonthStarts,
			toDate: this.currentMonthEnds
		};
		this.applicationService.totalReceivedMsgCount(args).subscribe(async (data) => {
			if (data && data.status == true) {
				this.monthlyReceivedCount = data.info.totalCount ? data.info.totalCount : 0;
				this.monthlyReceivedCountLoader = false;
			} else {
				this.monthlyReceivedCountLoader = false;
			}
		}, err => {
			this.monthlyReceivedCountLoader = false;
		});
	}

	receivedYearlyCount() {
		this.yearlyReceivedCountLoader = true;
		this.currentYearStarts = moment().startOf('year').format('YYYY-MM-DD');
		this.currentYearEnds = moment().endOf('week').format('YYYY-MM-DD');
		let args = {
			developerId: this.selectedApplication.developerId,
		applicationId: this.selectedApplication.applicationId,
			fromDate: this.currentYearStarts,
			toDate: this.currentYearEnds
		};
		this.applicationService.totalReceivedMsgCount(args).subscribe(async (data) => {
			if (data && data.status == true) {
				this.yearlyReceivedCount = data.info.totalCount ? data.info.totalCount : 0;
				this.yearlyReceivedCountLoader = false;
			} else {
				this.yearlyReceivedCountLoader = false;
			}
		}, err => {
			this.yearlyReceivedCountLoader = false;
		});
	}

















	receivedTotalMessagesCount() {
		this.totalReceivedMessageLoader = true;
		let args = {
			developerId: this.selectedApplication.developerId,
		applicationId: this.selectedApplication.applicationId,
			
		};
		this.applicationService.totalReceivedMsgCount(args).subscribe(async (data) => {
			if (data && data.status == true) {
				this.totalReceivedMessagesCount = data.info.totalCount ? data.info.totalCount : 0;
				this.totalReceivedMessageLoader = false;
			} else {
				this.totalReceivedMessageLoader = false;
			}
		}, err => {
			this.totalReceivedMessageLoader = false;
		});
	}







	getReceivedCountByConnectors() {
		this.totalReceivedCountByConnectorsLoader = true;
		this.loadershow = true;
		let args = {
			developerId: this.selectedApplication.developerId,
			applicationId: this.selectedApplication.applicationId,
			connectorId: this.selectedConnector.id
		};
		this.messagesService.getReceivedCountByConnectors(args).subscribe(async (data) => {
			this.loadershow = false;
			if (data && data.status == true) {
				this.totalReceivedCountByConnectors = data.info;
				this.totalReceivedCountByConnectorsLoader = false;
			} else {
				this.totalReceivedCountByConnectorsLoader = false;
			}		
		}, err => {
			this.totalReceivedCountByConnectorsLoader = false;
		});
	}

	/** CHART DATA LIST CALL**/
	getDashboardChartDetails() {
		let args = {
			
			developerId: this.selectedApplication.developerId
			, applicationId: this.selectedApplication.applicationId
			, connectorId: this.selectedConnector.id
			, fromDate: this.fromDate
			, toDate: this.toDate
		};
		
		console.log("FromDate",args.fromDate);
		console.log("ToDate",args.toDate);

		this.messagesService.getDashboardChartSentDetails(args).subscribe(data => {
			this.loadershow = false;		
			if(data && data.status == true) {
				this.dashboardChartSentDetails = data.info[this.selectedConnector.name];
				this.makeCharts();
			} else {
				this.noRecords = true;
				if(this.chart) {
					this.chart.clear();
				}
			}	
		});

		this.messagesService.getDashboardChartReceivedDetails(args).subscribe(data => {
			this.loadershow = false;		
			if(data && data.status == true) {
				this.dashboardChartReceivedDetails = data.info[this.selectedConnector.name];
				this.makeReceivedCharts();
			} else {
				this.noRecordsReceived = true;
				if(this.chartReceived) {
					this.chartReceived.clear();
				}
			}	
		});

		this.messagesService.getDashboardChartTemplateDetails(args).subscribe(data => {
			this.loadershow = false;		
			if(data && data.status == true) {
				this.dashboardChartTemplateDetails = data.info[this.selectedConnector.name];
				this.makeTemplateCharts();
			} else {
				this.noTemplateRecordsReceived = true;
				if(this.templateChart) {
					this.templateChart.clear();
				}
			}	
		});
	}

	/** SELECTED APPLICATION CHANGE **/
	async selectChangeApplication() {
		let connectorData = await this.getConnectorsList();
		if(connectorData && connectorData.status == true) {
			this.connectors = connectorData['info'];
			this.selectedConnector = this.connectors[0];
		}else {
			this.connectors = [];
			this.selectedConnector = '';
		}

		this.getDashboardChartDetails();
		this.sentDataCountSection();
		this.receivedDataCountSection();
		this.getDateWiseTotalMessageCount();
		this.getDatewiseTotalReceivedCount();
	}

	/** SELECTED CHANNEL CHANGE **/
	selectChangeChannel(connector){
		this.selectedConnector = connector;
		this.getSentCountByConnectors();
		this.getReceivedCountByConnectors();
		if (this.selectedConnector.hasHsm){
			this.sentHsmCount();
		}
		this.getDashboardChartDetails();
	}

	/** SELECTED PERIOD CHANGE **/
	selectChangePeriod(period) {
		this.selectedPeriod = period;
		this.getDashboardChartDetails();
  	}
  	
	/** APPLICATION TOTAL SENT MESSAGE COUNT(DATEWISE) **/
	getDateWiseTotalMessageCount() {
		this.totalDateCountLoader = true;
		let args = {
			developerId: this.userData.id,
			applicationId: this.selectedApp.id,
			fromDate: this.fromDate,
			toDate: this.toDate
		};
		this.applicationService.totalSentMsgCount(args).subscribe(async (data) => {
			if(data && data.status == true) { 
				this.totalDateCount = data.info.totalCount;
				this.totalDateCountLoader = false;
			} else {
				this.totalDateCountLoader = false;
			}
  		},err =>{
			this.totalDateCountLoader = false;
		});
	}
	
	/** APPLICATION TOTAL RECEIVED MESSAGE COUNT(DATEWISE) **/
	getDatewiseTotalReceivedCount() {
		this.totalReceivedDateCountLoader = true;
		let args = {
			developerId: this.userData.id,
			applicationId: this.selectedApp.id,
			fromDate: this.fromDate,
			toDate: this.toDate
		};
		this.applicationService.totalReceivedMsgCount(args).subscribe(async (data) => {
			if(data && data.status == true) {
				this.totalReceivedDateCount = data.info.totalCount;
				this.totalReceivedDateCountLoader = false;
			} else {
				this.totalReceivedDateCountLoader = false;
			}		
		}, err => {
			this.totalReceivedDateCountLoader = false;
		});
	}
	
	/** PROCESS DATA FOR CHARTS BY DAY WEEK MONTH **/
	processChartDataDetails(chartDetails) {
		let dataProvider = [];
		if (chartDetails) {
			if (this.selectedPeriod === 'day') {
				Object.keys(chartDetails).forEach((key) => {
					let obj = {};
					obj['year'] = key;
					obj['value'] = chartDetails[key];
					dataProvider.push(obj);
				})
			}
			  
			let res = [];
			if (this.selectedPeriod === 'week') {
				Object.keys(chartDetails).forEach((key) => {
					const currentWeek = moment(key, 'YYYY-MM-DD').isoWeek();
					const currentYear = moment(key, 'YYYY-MM-DD').year();
					
					let obj2 = {};
					obj2['year'] = 'Week ' + currentWeek + '-' + currentYear;
					obj2['value'] = chartDetails[key];
					res.push(obj2);
				})
				let weekArray = _.chain(res).groupBy('year').map((value, key) => {
					let values = _.pluck(value, 'value');
					let count = values.reduce((a, b) => {
						return a + b;
					})
					return {
						year: key,
						value: count
					}
				}).value();
		
				_.filter(weekArray, (items) => {
					dataProvider.push(items);
				})
			}
	  
			let res2 = [];
			if (this.selectedPeriod === 'month') {
				Object.keys(chartDetails).forEach((key) => {
					const currentMonthYear = moment(key).format('YYYY-MMM')
					
					let obj2 = {};
					obj2['year'] = currentMonthYear;
					obj2['value'] = chartDetails[key];
					res2.push(obj2);
				})
				let monthArray = _.chain(res2).groupBy('year').map((value, key) => {
					let values = _.pluck(value, 'value');
					let count = values.reduce((a, b) => {
						return a + b;
					})
					return {
						year: key,
						value: count
					}
				})
					.value();
				_.filter(monthArray, (items) => {
					dataProvider.push(items);
				})
			}
		}
		return dataProvider;
	}
	
	/** SENT MESSAGES CHART CREATION **/
	makeCharts() {
		let sentChartData = [];
		if (this.dashboardChartSentDetails) {
			this.noRecords = false;
			sentChartData = this.processChartDataDetails(this.dashboardChartSentDetails);
			if (sentChartData) {
				this.sentChartOptions.dataProvider = sentChartData;
				this.chart = this.AmCharts.makeChart("chartdiv", this.sentChartOptions, 1);
			} else {
				this.noRecords = true;
				if (this.chart) {
					this.chart.clear();
				}
			}
		} else {
			this.noRecords = true;
			if (this.chart) {
				this.chart.clear();
			}
		}
	}
	
	/** RECEIVED MESSAGES CHART CREATION **/
  	makeReceivedCharts() {
		let receivedChartData = [];
		if (this.dashboardChartReceivedDetails) {
			this.noRecordsReceived = false;	
			receivedChartData = this.processChartDataDetails(this.dashboardChartReceivedDetails);
			if (receivedChartData) {
				this.receivedChartOptions.dataProvider = receivedChartData;
				this.chartReceived = this.AmCharts.makeChart("chartdivReceived", this.receivedChartOptions, 1);
			}else {
				this.noRecordsReceived = true;
				if(this.chartReceived) {
					this.chartReceived.clear();
				}
			}
		}else {
			this.noRecordsReceived = true;
			if(this.chartReceived) {
				this.chartReceived.clear();
			}
		}
	}


	/** TEMPLATE MESSAGES CHART CREATION **/
	makeTemplateCharts() {
		let templateChartData = [];
		if (this.dashboardChartTemplateDetails) {
			this.noTemplateRecordsReceived = false;	
			templateChartData = this.processChartDataDetails(this.dashboardChartTemplateDetails);
			if (templateChartData) {
				this.templateChartOptions.dataProvider = templateChartData;
				this.templateChart = this.AmCharts.makeChart("chartdivTemplate", this.templateChartOptions, 1);
			}else {
				this.noTemplateRecordsReceived = true;
				if(this.templateChart) {
					this.templateChart.clear();
				}
			}
		}else {
			this.noTemplateRecordsReceived = true;
			if(this.templateChart) {
				this.templateChart.clear();
			}
		}
	}
	
	/** SELECT DATES ON CALENDAR **/
	selectDates(events) {
	  	if(events) {
			this.fromDate = moment(events[0]).format('YYYY-MM-DD');
		  	this.toDate = moment(events[1]).format('YYYY-MM-DD');
			this.getDashboardChartDetails();
		}	  
  	}
  
	/** SELECT DATE RANGE **/
	switchDateRange() {  
		if(this.selectedDateRange === 'last30') {
			this.chooseDate = false;
			this.selectedPeriod = 'day';
			this.toDate = moment(new Date()).format('YYYY-MM-DD');
			this.fromDate = moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD');
			this.getDashboardChartDetails();
		}
		if(this.selectedDateRange === 'choosedate') {
			this.chooseDate = true;
			this.selectedPeriod = 'week';
			this.toDate = moment(new Date()).format('YYYY-MM-DD');
			this.fromDate = moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD');
			//this.getDashboardChartDetails();
		}
	}
	  
	/** TOTAL MESSAGES SENT **/
	totalSentMsgCount(args) {
		this.totalSentMessageLoader = true;
		this.applicationService.totalSentMsgCount(args).subscribe( res =>{
			if (res && res.status == true) {
				console.log("/application/sent/count", res.info.totalCount);
				this.totalSentMessages = res.info.totalCount;
				this.totalSentMessageLoader = false;
			} else{
				this.totalSentMessageLoader = false;
			}	
		},err =>{
			this.totalSentMessageLoader = false;
		})
	}
	
	/** TAB SWITCH MESSAGE SENT AND RECEIVED**/
	switchTab() {
		if (this.showMessageReceivedStatus === true) {
			this.showMessageReceivedStatus = false;
			this.showMessageSentStatus = true;
		} else {
			this.showMessageReceivedStatus = true;
			this.showMessageSentStatus = false;			
		}
	}	

	/** TOTAL MESSAGES RECEIVED **/
	totalReceivedMsgCount(args){
		this.totalReceivedMessageLoader = true;
		this.applicationService.totalReceivedMsgCount(args).subscribe( res =>{
			if(res && res.status == true){
				console.log("/application/received/count", res.info.totalCount);
				this.totalReceivedMessages = res.info.totalCount;
				this.totalReceivedMessageLoader = false;
			} else{
				this.totalReceivedMessageLoader = false;
			}
		},err =>{
			this.totalReceivedMessageLoader = false;
		})
	}

}
